import { render, staticRenderFns } from "./IconRegistered.vue?vue&type=template&id=3e654c66&"
import script from "./IconRegistered.vue?vue&type=script&lang=js&"
export * from "./IconRegistered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports